import React from 'react';

export const Alert = ({ type = 'error', children }) =>
    children ? (
        <div className={`psp-alert psp-alert--${type}`} role={type === 'error' ? 'alert' : 'status'}>
            {children}
        </div>
    ) : null;

export const SubmitButton = ({ loading, children, variant = 'primary', disabled, ...rest }) => (
    <button
        type="submit"
        className={`psp-btn psp-btn--${variant}`}
        {...rest}
        disabled={loading || disabled}
    >
        {loading && <i className="fas fa-spinner fa-spin" aria-hidden="true" />}
        {children}
    </button>
);
